/**
 * 날짜·시간 표시 — **단일 출처**.
 * 정책: 화면에 보이는 모든 날짜/시간은 **무조건 한국시간(KST)**.
 * 서버는 UTC로 돌고 사용자는 해외에서 접속할 수 있으므로, 기기 시간대를 절대 따라가지 않는다.
 * 통계 집계 키(일자)도 같은 기준을 써야 서버·웹 계산이 어긋나지 않는다.
 */
export const DISPLAY_TIME_ZONE = 'Asia/Seoul';
export const DISPLAY_LOCALE = 'ko-KR';

const fmt = (opts: Intl.DateTimeFormatOptions, locale = DISPLAY_LOCALE) =>
  new Intl.DateTimeFormat(locale, { ...opts, timeZone: DISPLAY_TIME_ZONE });

/** 화면용 날짜 — 기본 "2026년 8월 18일" (옵션으로 요일 등 추가 가능) */
export function formatDate(
  ms: number,
  opts: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' },
): string {
  return fmt(opts).format(new Date(ms));
}

/** KST 기준 연도 — 푸터 저작권 표기 등 */
export function kstYear(ms: number = Date.now()): number {
  return Number(fmt({ year: 'numeric' }, 'en-CA').format(new Date(ms)));
}

/** KST 기준 날짜 키 `YYYY-MM-DD` — 통계 집계·하루 1회 판정용 (en-CA가 ISO 형식) */
export function kstDay(ms: number = Date.now()): string {
  return fmt({ year: 'numeric', month: '2-digit', day: '2-digit' }, 'en-CA').format(new Date(ms));
}

/** KST 오프셋 (한국은 서머타임 없음) */
const KST_OFFSET_MS = 9 * 60 * 60 * 1000;
const DAY_MS = 24 * 60 * 60 * 1000;

/** 다음 한국시간 자정(epoch ms) — 하루 이용 횟수 초기화 시각 */
export function nextKstMidnight(ms: number = Date.now()): number {
  return (Math.floor((ms + KST_OFFSET_MS) / DAY_MS) + 1) * DAY_MS - KST_OFFSET_MS;
}
